import { createSlice } from "@reduxjs/toolkit";
import {
  getClientsService,
  getClientByIdService,
  updateClientService,
  createClientService,
} from "../services/clients_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  clientsList: [],
  metaClient: null,
  clientInfo: null,
  isLoadingAction: false,
};

const slice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getClientsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsList = action.payload?.data?.data?.data;
        state.metaClient = action?.payload?.data?.data;
      })
      .addCase(getClientsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getClientsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getClientByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientInfo = action.payload?.data?.data;
      })
      .addCase(getClientByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getClientByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(createClientService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(createClientService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(createClientService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      })
      .addCase(updateClientService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(updateClientService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(updateClientService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
